import React, { useEffect } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { useState } from 'react';
import { normalizeDate } from '../../utils/functions';
import { get } from '../../services/back.service';

function SearchFormPayment({ searching }) {
  const currentDate = new Date();
  const defaultDate = normalizeDate(currentDate);
  const [list_client, setClientList] = useState([])
  const [infoForm, setForm] = useState({
    state: 'PE',
    init_date: defaultDate,
    end_date: defaultDate,
    cliente_name: 'Cargando ...',
  });

  const localSearch = () => {
    searching(infoForm);
  };

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/client/list_client_serviced/', {});
      if (respo.success) {
        setClientList(respo.data);
        setForm(prevInfoForm => ({ ...prevInfoForm, cliente_name: '' }))
      }
    };
    initForm();
  }, []);

  return (
    <Container className="m-3">
      <Form>
        <Row>
          {/* <Col>
            <Form.Label>Placa Vehiculo</Form.Label>
            <Form.Control
              name="placa"
              value={infoForm.placa}
              type="text"
              className="fw-bold text-uppercase"
              onChange={(e) =>
                setForm({ ...infoForm, [e.target.name]: e.target.value })
              }
            />
          </Col>*/}
          <Col>
            <Form.Label htmlFor="brand">Cliente</Form.Label>
            <Form.Control
              list="client_list_data"
              type="text"
              name="cliente_name"
              value={infoForm.cliente_name}
              className="fw-bold text-uppercase"
              onChange={(e) =>
                setForm({ ...infoForm, [e.target.name]: e.target.value })
              }
              required
            />
            <datalist id="client_list_data">
              {
                list_client.map((element, i) => <option key={i} value={element.name}>{element.name}</option>)
              }
            </datalist>
          </Col>
          <Col>
            <Form.Label>Estado</Form.Label>
            <Form.Select
              name="state"
              value={infoForm.state}
              onChange={(e) => setForm({ ...infoForm, [e.target.name]: e.target.value })}
              aria-label="Default select example"
              required
            >
              <option value="">Todos</option>
              <option value="PE">Pendiente</option>
              <option value="PA">Pagado</option>
            </Form.Select>
          </Col>
          <Col>
            <Form.Label>Fecha Inicial</Form.Label>
            <Form.Control
              name="init_date"
              value={infoForm.init_date}
              type="date"
              onChange={(e) =>
                setForm({ ...infoForm, [e.target.name]: e.target.value })
              }
            />
          </Col>
          <Col>
            <Form.Label>Fecha Fin</Form.Label>
            <Form.Control
              name="end_date"
              value={infoForm.end_date}
              type="date"
              onChange={(e) =>
                setForm({ ...infoForm, [e.target.name]: e.target.value })
              }
            />
          </Col>
        </Row>
        <Row>
          <Button
            onClick={localSearch}
            variant="outline-primary"
            className="m-3"
          >
            Buscar
          </Button>
        </Row>
      </Form>
    </Container>
  );
}

export default SearchFormPayment;
